import React from 'react';

/**
 * Outline WhatsApp icon — recognizable WhatsApp silhouette in BIMCORP's
 * outline-icon style. Stroke-only, currentColor.
 *
 * Stroke is intentionally thin (1.25px at 16px) so the inner receiver glyph
 * stays legible at small sizes instead of looking clumped.
 */
export const WhatsAppIcon = ({ size = 16, strokeWidth = 1.25, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    {/* Chat bubble outline with corner tail */}
    <path d="M21 12a9 9 0 0 1-13.45 7.8L3 21l1.27-4.4A9 9 0 1 1 21 12z" />
    {/* WhatsApp receiver glyph */}
    <path d="M16.5 14.3c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15s-.77.96-.94 1.16-.35.22-.65.07-1.26-.46-2.4-1.48a8.94 8.94 0 0 1-1.67-2.07c-.17-.3-.02-.46.13-.6.14-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.91-2.18-.24-.57-.48-.5-.66-.5h-.57c-.2 0-.51.07-.78.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.1 3.21 5.08 4.5.71.3 1.26.49 1.69.62.71.22 1.36.19 1.87.12.57-.08 1.77-.72 2.02-1.42.24-.7.24-1.3.17-1.42-.07-.12-.27-.2-.57-.35z" />
  </svg>
);
